/* ==========================================================================
   CLARITY HEALTH CO — TEAM CARDS
   Each card's collapsed bar and expanded panel swap in place (no reflow, no page
   jump). Cards toggle independently. aria-expanded / aria-hidden stay in sync,
   and focus follows the control that becomes visible.
   ========================================================================== */
(function () {
  function wire(card) {
    if (card.dataset.teamWired === '1') return;
    var bar = card.querySelector('[data-team-open]');
    var head = card.querySelector('[data-team-close]');
    var panel = card.querySelector('.clarity-team__panel');
    if (!bar || !head || !panel) return;
    card.dataset.teamWired = '1';

    function set(open, focus) {
      card.classList.toggle('is-open', open);
      bar.setAttribute('aria-expanded', String(open));
      head.setAttribute('aria-expanded', String(open));
      panel.setAttribute('aria-hidden', String(!open));
      if (focus) (open ? head : bar).focus({ preventScroll: true });
    }

    bar.addEventListener('click', function () { set(true, true); });
    head.addEventListener('click', function () { set(false, true); });
  }

  function init() {
    document.querySelectorAll('[data-team]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target || document;
    (t.querySelectorAll ? t : document).querySelectorAll('[data-team]').forEach(wire);
  });
})();
